import { __exportAll } from "../_virtual/_rolldown/runtime.mjs";
import { isSymbol } from "./predicate/isSymbol.mjs";
import { toNumber } from "./util/toNumber.mjs";
import { toFinite } from "./util/toFinite.mjs";
import { toInteger } from "./util/toInteger.mjs";
import { isArray } from "./predicate/isArray.mjs";
import { isPlainObject } from "./predicate/isPlainObject.mjs";
import { isEqualsSameValueZero } from "../_internal/isEqualsSameValueZero.mjs";
import "./util/eq.mjs";
import { isEqual } from "../predicate/isEqual.mjs";
import { castArray } from "./array/castArray.mjs";
import { isArrayLike } from "./predicate/isArrayLike.mjs";
import { chunk } from "./array/chunk.mjs";
import { compact } from "./array/compact.mjs";
import { concat } from "./array/concat.mjs";
import { toString } from "./util/toString.mjs";
import { toPath } from "./util/toPath.mjs";
import { get } from "./object/get.mjs";
import { property } from "./object/property.mjs";
import { isObject } from "./predicate/isObject.mjs";
import { isMatchWith } from "./predicate/isMatchWith.mjs";
import { isMatch } from "./predicate/isMatch.mjs";
import { matches } from "./predicate/matches.mjs";
import { cloneDeepWith } from "./object/cloneDeepWith.mjs";
import { cloneDeep } from "./object/cloneDeep.mjs";
import { isArguments } from "./predicate/isArguments.mjs";
import { has } from "./object/has.mjs";
import { matchesProperty } from "./predicate/matchesProperty.mjs";
import { iteratee } from "./util/iteratee.mjs";
import { countBy } from "./array/countBy.mjs";
import { isObjectLike } from "./predicate/isObjectLike.mjs";
import { isArrayLikeObject } from "./predicate/isArrayLikeObject.mjs";
import { difference } from "./array/difference.mjs";
import { last } from "./array/last.mjs";
import { differenceBy } from "./array/differenceBy.mjs";
import { differenceWith } from "./array/differenceWith.mjs";
import { drop } from "./array/drop.mjs";
import { dropRight } from "./array/dropRight.mjs";
import { dropRightWhile } from "./array/dropRightWhile.mjs";
import { dropWhile } from "./array/dropWhile.mjs";
import { forEach } from "./array/forEach.mjs";
import "./array/each.mjs";
import { forEachRight } from "./array/forEachRight.mjs";
import "./array/eachRight.mjs";
import { every } from "./array/every.mjs";
import { isString } from "./predicate/isString.mjs";
import { fill } from "./array/fill.mjs";
import { filter } from "./array/filter.mjs";
import { find } from "./array/find.mjs";
import { identity } from "./function/identity.mjs";
import { findIndex } from "./array/findIndex.mjs";
import { findLast } from "./array/findLast.mjs";
import { findLastIndex } from "./array/findLastIndex.mjs";
import { head } from "./array/head.mjs";
import "./array/first.mjs";
import { flatten } from "./array/flatten.mjs";
import { flattenDepth } from "./array/flattenDepth.mjs";
import { map } from "./array/map.mjs";
import { flatMap } from "./array/flatMap.mjs";
import { flatMapDepth } from "./array/flatMapDepth.mjs";
import { flatMapDeep } from "./array/flatMapDeep.mjs";
import { flattenDeep } from "./array/flattenDeep.mjs";
import { groupBy } from "./array/groupBy.mjs";
import { includes } from "./array/includes.mjs";
import { indexOf } from "./array/indexOf.mjs";
import { initial } from "./array/initial.mjs";
import { intersection } from "./array/intersection.mjs";
import { intersectionBy } from "./array/intersectionBy.mjs";
import { uniq } from "./array/uniq.mjs";
import { intersectionWith } from "./array/intersectionWith.mjs";
import { invokeMap } from "./array/invokeMap.mjs";
import { join } from "./array/join.mjs";
import { reduce } from "./array/reduce.mjs";
import { keyBy } from "./array/keyBy.mjs";
import { lastIndexOf } from "./array/lastIndexOf.mjs";
import { nth } from "./array/nth.mjs";
import { orderBy } from "./array/orderBy.mjs";
import { partition } from "./array/partition.mjs";
import { pull } from "./array/pull.mjs";
import { pullAll } from "./array/pullAll.mjs";
import { pullAllBy } from "./array/pullAllBy.mjs";
import { pullAllWith } from "./array/pullAllWith.mjs";
import { at } from "./object/at.mjs";
import { unset } from "./object/unset.mjs";
import { pullAt } from "./array/pullAt.mjs";
import { reduceRight } from "./array/reduceRight.mjs";
import { negate } from "./function/negate.mjs";
import { reject } from "./array/reject.mjs";
import { remove } from "./array/remove.mjs";
import { reverse } from "./array/reverse.mjs";
import { sample } from "./array/sample.mjs";
import { clamp } from "./math/clamp.mjs";
import { isMap } from "./predicate/isMap.mjs";
import { toArray } from "./util/toArray.mjs";
import { sampleSize } from "./array/sampleSize.mjs";
import { values } from "./object/values.mjs";
import { isNil } from "./predicate/isNil.mjs";
import { shuffle } from "./array/shuffle.mjs";
import { size } from "./array/size.mjs";
import { slice } from "./array/slice.mjs";
import { some } from "./array/some.mjs";
import { sortBy } from "./array/sortBy.mjs";
import { isNaN } from "./predicate/isNaN.mjs";
import { sortedIndexBy } from "./array/sortedIndexBy.mjs";
import { isNumber } from "./predicate/isNumber.mjs";
import { sortedIndex } from "./array/sortedIndex.mjs";
import { sortedIndexOf } from "./array/sortedIndexOf.mjs";
import { sortedLastIndexBy } from "./array/sortedLastIndexBy.mjs";
import { sortedLastIndex } from "./array/sortedLastIndex.mjs";
import { sortedLastIndexOf } from "./array/sortedLastIndexOf.mjs";
import { tail } from "./array/tail.mjs";
import { take } from "./array/take.mjs";
import { takeRight } from "./array/takeRight.mjs";
import { takeRightWhile } from "./array/takeRightWhile.mjs";
import { takeWhile } from "./array/takeWhile.mjs";
import { union } from "./array/union.mjs";
import { unionBy } from "./array/unionBy.mjs";
import { unionWith } from "./array/unionWith.mjs";
import { uniqBy } from "./array/uniqBy.mjs";
import { uniqWith } from "./array/uniqWith.mjs";
import { unzip } from "./array/unzip.mjs";
import { unzipWith } from "./array/unzipWith.mjs";
import { without } from "./array/without.mjs";
import { xor } from "./array/xor.mjs";
import { xorBy } from "./array/xorBy.mjs";
import { xorWith } from "./array/xorWith.mjs";
import { zip } from "./array/zip.mjs";
import { zipObject } from "./array/zipObject.mjs";
import { updateWith } from "./object/updateWith.mjs";
import { set } from "./object/set.mjs";
import { zipObjectDeep } from "./array/zipObjectDeep.mjs";
import { zipWith } from "./array/zipWith.mjs";
import { after } from "./function/after.mjs";
import { ary } from "./function/ary.mjs";
import { attempt } from "./function/attempt.mjs";
import { before } from "./function/before.mjs";
import { bind } from "./function/bind.mjs";
import { bindKey } from "./function/bindKey.mjs";
import { curry } from "./function/curry.mjs";
import { curryRight } from "./function/curryRight.mjs";
import { debounce } from "./function/debounce.mjs";
import { defer } from "./function/defer.mjs";
import { delay } from "./function/delay.mjs";
import { flip } from "./function/flip.mjs";
import { flow } from "./function/flow.mjs";
import { flowRight } from "./function/flowRight.mjs";
import { memoize } from "./function/memoize.mjs";
import { nthArg } from "./function/nthArg.mjs";
import { once } from "./function/once.mjs";
import { overArgs } from "./function/overArgs.mjs";
import { partial } from "./function/partial.mjs";
import { partialRight } from "./function/partialRight.mjs";
import { rearg } from "./function/rearg.mjs";
import { rest } from "./function/rest.mjs";
import { spread } from "./function/spread.mjs";
import { throttle } from "./function/throttle.mjs";
import { unary } from "./function/unary.mjs";
import { wrap } from "./function/wrap.mjs";
import { add } from "./math/add.mjs";
import { ceil } from "./math/ceil.mjs";
import { divide } from "./math/divide.mjs";
import { floor } from "./math/floor.mjs";
import { inRange } from "./math/inRange.mjs";
import { max } from "./math/max.mjs";
import { maxBy } from "./math/maxBy.mjs";
import { sumBy } from "./math/sumBy.mjs";
import { sum } from "./math/sum.mjs";
import { mean } from "./math/mean.mjs";
import { meanBy } from "./math/meanBy.mjs";
import { min } from "./math/min.mjs";
import { minBy } from "./math/minBy.mjs";
import { multiply } from "./math/multiply.mjs";
import { parseInt } from "./math/parseInt.mjs";
import { random } from "./math/random.mjs";
import { range } from "./math/range.mjs";
import { rangeRight } from "./math/rangeRight.mjs";
import { round } from "./math/round.mjs";
import { subtract } from "./math/subtract.mjs";
import { noop } from "./function/noop.mjs";
import { isTypedArray } from "./predicate/isTypedArray.mjs";
import { times } from "./util/times.mjs";
import { keys } from "./object/keys.mjs";
import { assign } from "./object/assign.mjs";
import { keysIn } from "./object/keysIn.mjs";
import { assignIn } from "./object/assignIn.mjs";
import { assignInWith } from "./object/assignInWith.mjs";
import { assignWith } from "./object/assignWith.mjs";
import { clone } from "./object/clone.mjs";
import { cloneWith } from "./object/cloneWith.mjs";
import { create } from "./object/create.mjs";
import { defaults } from "./object/defaults.mjs";
import { defaultsDeep } from "./object/defaultsDeep.mjs";
import "./object/extend.mjs";
import "./object/extendWith.mjs";
import { findKey } from "./object/findKey.mjs";
import { findLastKey } from "./object/findLastKey.mjs";
import { forIn } from "./object/forIn.mjs";
import { forInRight } from "./object/forInRight.mjs";
import { forOwn } from "./object/forOwn.mjs";
import { forOwnRight } from "./object/forOwnRight.mjs";
import { fromPairs } from "./object/fromPairs.mjs";
import { functions } from "./object/functions.mjs";
import { functionsIn } from "./object/functionsIn.mjs";
import { hasIn } from "./object/hasIn.mjs";
import { invert } from "./object/invert.mjs";
import { invertBy } from "./object/invertBy.mjs";
import { mapKeys } from "./object/mapKeys.mjs";
import { mapValues } from "./object/mapValues.mjs";
import { mergeWith } from "./object/mergeWith.mjs";
import { merge } from "./object/merge.mjs";
import { omit } from "./object/omit.mjs";
import { omitBy } from "./object/omitBy.mjs";
import { pick } from "./object/pick.mjs";
import { pickBy } from "./object/pickBy.mjs";
import { propertyOf } from "./object/propertyOf.mjs";
import { result } from "./object/result.mjs";
import { setWith } from "./object/setWith.mjs";
import { toDefaulted } from "./object/toDefaulted.mjs";
import { toPairs } from "./object/toPairs.mjs";
import { toPairsIn } from "./object/toPairsIn.mjs";
import { isBuffer } from "./predicate/isBuffer.mjs";
import { transform } from "./object/transform.mjs";
import { update } from "./object/update.mjs";
import { valuesIn } from "./object/valuesIn.mjs";
import { isFunction } from "./predicate/isFunction.mjs";
import { isLength } from "./predicate/isLength.mjs";
import { isNative } from "./predicate/isNative.mjs";
import { isNull } from "./predicate/isNull.mjs";
import { isUndefined } from "./predicate/isUndefined.mjs";
import { conformsTo } from "./predicate/conformsTo.mjs";
import { conforms } from "./predicate/conforms.mjs";
import { isArrayBuffer } from "./predicate/isArrayBuffer.mjs";
import { isBoolean } from "./predicate/isBoolean.mjs";
import { isDate } from "./predicate/isDate.mjs";
import { isElement } from "./predicate/isElement.mjs";
import { isEmpty } from "./predicate/isEmpty.mjs";
import { isEqualWith } from "./predicate/isEqualWith.mjs";
import { isError } from "./predicate/isError.mjs";
import { isFinite } from "./predicate/isFinite.mjs";
import { isInteger } from "./predicate/isInteger.mjs";
import { isRegExp } from "./predicate/isRegExp.mjs";
import { isSafeInteger } from "./predicate/isSafeInteger.mjs";
import { isSet } from "./predicate/isSet.mjs";
import { isWeakMap } from "./predicate/isWeakMap.mjs";
import { isWeakSet } from "./predicate/isWeakSet.mjs";
import { capitalize } from "./string/capitalize.mjs";
import { bindAll } from "./util/bindAll.mjs";
import { deburr } from "./string/deburr.mjs";
import { camelCase } from "./string/camelCase.mjs";
import { endsWith } from "./string/endsWith.mjs";
import { escape } from "./string/escape.mjs";
import { escapeRegExp } from "./string/escapeRegExp.mjs";
import { kebabCase } from "./string/kebabCase.mjs";
import { lowerCase } from "./string/lowerCase.mjs";
import { lowerFirst } from "./string/lowerFirst.mjs";
import { pad } from "./string/pad.mjs";
import { padEnd } from "./string/padEnd.mjs";
import { padStart } from "./string/padStart.mjs";
import { repeat } from "./string/repeat.mjs";
import { replace } from "./string/replace.mjs";
import { snakeCase } from "./string/snakeCase.mjs";
import { split } from "./string/split.mjs";
import { startCase } from "./string/startCase.mjs";
import { startsWith } from "./string/startsWith.mjs";
import { template, templateSettings } from "./string/template.mjs";
import "./string/templateSettings.mjs";
import { toLower } from "./string/toLower.mjs";
import { toUpper } from "./string/toUpper.mjs";
import { trim } from "./string/trim.mjs";
import { trimEnd } from "./string/trimEnd.mjs";
import { trimStart } from "./string/trimStart.mjs";
import { truncate } from "./string/truncate.mjs";
import { unescape } from "./string/unescape.mjs";
import { upperCase } from "./string/upperCase.mjs";
import { upperFirst } from "./string/upperFirst.mjs";
import { words } from "./string/words.mjs";
import { cond } from "./util/cond.mjs";
import { constant } from "./util/constant.mjs";
import { defaultTo } from "./util/defaultTo.mjs";
import { gt } from "./util/gt.mjs";
import { gte } from "./util/gte.mjs";
import { invoke } from "./util/invoke.mjs";
import { lt } from "./util/lt.mjs";
import { lte } from "./util/lte.mjs";
import { method } from "./util/method.mjs";
import { methodOf } from "./util/methodOf.mjs";
import { now } from "./util/now.mjs";
import { over } from "./util/over.mjs";
import { overEvery } from "./util/overEvery.mjs";
import { overSome } from "./util/overSome.mjs";
import { stubArray } from "./util/stubArray.mjs";
import { stubFalse } from "./util/stubFalse.mjs";
import { stubObject } from "./util/stubObject.mjs";
import { stubString } from "./util/stubString.mjs";
import { stubTrue } from "./util/stubTrue.mjs";
import { toLength } from "./util/toLength.mjs";
import { toPlainObject } from "./util/toPlainObject.mjs";
import { toSafeInteger } from "./util/toSafeInteger.mjs";
import { uniqueId } from "./util/uniqueId.mjs";
//#region src/compat/compat.ts
var compat_exports = /* @__PURE__ */ __exportAll({
	add: () => add,
	after: () => after,
	ary: () => ary,
	assign: () => assign,
	assignIn: () => assignIn,
	assignInWith: () => assignInWith,
	assignWith: () => assignWith,
	at: () => at,
	attempt: () => attempt,
	before: () => before,
	bind: () => bind,
	bindAll: () => bindAll,
	bindKey: () => bindKey,
	camelCase: () => camelCase,
	capitalize: () => capitalize,
	castArray: () => castArray,
	ceil: () => ceil,
	chunk: () => chunk,
	clamp: () => clamp,
	clone: () => clone,
	cloneDeep: () => cloneDeep,
	cloneDeepWith: () => cloneDeepWith,
	cloneWith: () => cloneWith,
	compact: () => compact,
	concat: () => concat,
	cond: () => cond,
	conforms: () => conforms,
	conformsTo: () => conformsTo,
	constant: () => constant,
	countBy: () => countBy,
	create: () => create,
	curry: () => curry,
	curryRight: () => curryRight,
	debounce: () => debounce,
	deburr: () => deburr,
	defaultTo: () => defaultTo,
	defaults: () => defaults,
	defaultsDeep: () => defaultsDeep,
	defer: () => defer,
	delay: () => delay,
	difference: () => difference,
	differenceBy: () => differenceBy,
	differenceWith: () => differenceWith,
	divide: () => divide,
	drop: () => drop,
	dropRight: () => dropRight,
	dropRightWhile: () => dropRightWhile,
	dropWhile: () => dropWhile,
	each: () => forEach,
	eachRight: () => forEachRight,
	endsWith: () => endsWith,
	eq: () => isEqualsSameValueZero,
	escape: () => escape,
	escapeRegExp: () => escapeRegExp,
	every: () => every,
	extend: () => assignIn,
	extendWith: () => assignInWith,
	fill: () => fill,
	filter: () => filter,
	find: () => find,
	findIndex: () => findIndex,
	findKey: () => findKey,
	findLast: () => findLast,
	findLastIndex: () => findLastIndex,
	findLastKey: () => findLastKey,
	first: () => head,
	flatMap: () => flatMap,
	flatMapDeep: () => flatMapDeep,
	flatMapDepth: () => flatMapDepth,
	flatten: () => flatten,
	flattenDeep: () => flattenDeep,
	flattenDepth: () => flattenDepth,
	flip: () => flip,
	floor: () => floor,
	flow: () => flow,
	flowRight: () => flowRight,
	forEach: () => forEach,
	forEachRight: () => forEachRight,
	forIn: () => forIn,
	forInRight: () => forInRight,
	forOwn: () => forOwn,
	forOwnRight: () => forOwnRight,
	fromPairs: () => fromPairs,
	functions: () => functions,
	functionsIn: () => functionsIn,
	get: () => get,
	groupBy: () => groupBy,
	gt: () => gt,
	gte: () => gte,
	has: () => has,
	hasIn: () => hasIn,
	head: () => head,
	identity: () => identity,
	inRange: () => inRange,
	includes: () => includes,
	indexOf: () => indexOf,
	initial: () => initial,
	intersection: () => intersection,
	intersectionBy: () => intersectionBy,
	intersectionWith: () => intersectionWith,
	invert: () => invert,
	invertBy: () => invertBy,
	invoke: () => invoke,
	invokeMap: () => invokeMap,
	isArguments: () => isArguments,
	isArray: () => isArray,
	isArrayBuffer: () => isArrayBuffer,
	isArrayLike: () => isArrayLike,
	isArrayLikeObject: () => isArrayLikeObject,
	isBoolean: () => isBoolean,
	isBuffer: () => isBuffer,
	isDate: () => isDate,
	isElement: () => isElement,
	isEmpty: () => isEmpty,
	isEqual: () => isEqual,
	isEqualWith: () => isEqualWith,
	isError: () => isError,
	isFinite: () => isFinite,
	isFunction: () => isFunction,
	isInteger: () => isInteger,
	isLength: () => isLength,
	isMap: () => isMap,
	isMatch: () => isMatch,
	isMatchWith: () => isMatchWith,
	isNaN: () => isNaN,
	isNative: () => isNative,
	isNil: () => isNil,
	isNull: () => isNull,
	isNumber: () => isNumber,
	isObject: () => isObject,
	isObjectLike: () => isObjectLike,
	isPlainObject: () => isPlainObject,
	isRegExp: () => isRegExp,
	isSafeInteger: () => isSafeInteger,
	isSet: () => isSet,
	isString: () => isString,
	isSymbol: () => isSymbol,
	isTypedArray: () => isTypedArray,
	isUndefined: () => isUndefined,
	isWeakMap: () => isWeakMap,
	isWeakSet: () => isWeakSet,
	iteratee: () => iteratee,
	join: () => join,
	kebabCase: () => kebabCase,
	keyBy: () => keyBy,
	keys: () => keys,
	keysIn: () => keysIn,
	last: () => last,
	lastIndexOf: () => lastIndexOf,
	lowerCase: () => lowerCase,
	lowerFirst: () => lowerFirst,
	lt: () => lt,
	lte: () => lte,
	map: () => map,
	mapKeys: () => mapKeys,
	mapValues: () => mapValues,
	matches: () => matches,
	matchesProperty: () => matchesProperty,
	max: () => max,
	maxBy: () => maxBy,
	mean: () => mean,
	meanBy: () => meanBy,
	memoize: () => memoize,
	merge: () => merge,
	mergeWith: () => mergeWith,
	method: () => method,
	methodOf: () => methodOf,
	min: () => min,
	minBy: () => minBy,
	multiply: () => multiply,
	negate: () => negate,
	noop: () => noop,
	now: () => now,
	nth: () => nth,
	nthArg: () => nthArg,
	omit: () => omit,
	omitBy: () => omitBy,
	once: () => once,
	orderBy: () => orderBy,
	over: () => over,
	overArgs: () => overArgs,
	overEvery: () => overEvery,
	overSome: () => overSome,
	pad: () => pad,
	padEnd: () => padEnd,
	padStart: () => padStart,
	parseInt: () => parseInt,
	partial: () => partial,
	partialRight: () => partialRight,
	partition: () => partition,
	pick: () => pick,
	pickBy: () => pickBy,
	property: () => property,
	propertyOf: () => propertyOf,
	pull: () => pull,
	pullAll: () => pullAll,
	pullAllBy: () => pullAllBy,
	pullAllWith: () => pullAllWith,
	pullAt: () => pullAt,
	random: () => random,
	range: () => range,
	rangeRight: () => rangeRight,
	rearg: () => rearg,
	reduce: () => reduce,
	reduceRight: () => reduceRight,
	reject: () => reject,
	remove: () => remove,
	repeat: () => repeat,
	replace: () => replace,
	rest: () => rest,
	result: () => result,
	reverse: () => reverse,
	round: () => round,
	sample: () => sample,
	sampleSize: () => sampleSize,
	set: () => set,
	setWith: () => setWith,
	shuffle: () => shuffle,
	size: () => size,
	slice: () => slice,
	snakeCase: () => snakeCase,
	some: () => some,
	sortBy: () => sortBy,
	sortedIndex: () => sortedIndex,
	sortedIndexBy: () => sortedIndexBy,
	sortedIndexOf: () => sortedIndexOf,
	sortedLastIndex: () => sortedLastIndex,
	sortedLastIndexBy: () => sortedLastIndexBy,
	sortedLastIndexOf: () => sortedLastIndexOf,
	split: () => split,
	spread: () => spread,
	startCase: () => startCase,
	startsWith: () => startsWith,
	stubArray: () => stubArray,
	stubFalse: () => stubFalse,
	stubObject: () => stubObject,
	stubString: () => stubString,
	stubTrue: () => stubTrue,
	subtract: () => subtract,
	sum: () => sum,
	sumBy: () => sumBy,
	tail: () => tail,
	take: () => take,
	takeRight: () => takeRight,
	takeRightWhile: () => takeRightWhile,
	takeWhile: () => takeWhile,
	template: () => template,
	templateSettings: () => templateSettings,
	throttle: () => throttle,
	times: () => times,
	toArray: () => toArray,
	toDefaulted: () => toDefaulted,
	toFinite: () => toFinite,
	toInteger: () => toInteger,
	toLength: () => toLength,
	toLower: () => toLower,
	toNumber: () => toNumber,
	toPairs: () => toPairs,
	toPairsIn: () => toPairsIn,
	toPath: () => toPath,
	toPlainObject: () => toPlainObject,
	toSafeInteger: () => toSafeInteger,
	toString: () => toString,
	toUpper: () => toUpper,
	transform: () => transform,
	trim: () => trim,
	trimEnd: () => trimEnd,
	trimStart: () => trimStart,
	truncate: () => truncate,
	unary: () => unary,
	unescape: () => unescape,
	union: () => union,
	unionBy: () => unionBy,
	unionWith: () => unionWith,
	uniq: () => uniq,
	uniqBy: () => uniqBy,
	uniqWith: () => uniqWith,
	uniqueId: () => uniqueId,
	unset: () => unset,
	unzip: () => unzip,
	unzipWith: () => unzipWith,
	update: () => update,
	updateWith: () => updateWith,
	upperCase: () => upperCase,
	upperFirst: () => upperFirst,
	values: () => values,
	valuesIn: () => valuesIn,
	without: () => without,
	words: () => words,
	wrap: () => wrap,
	xor: () => xor,
	xorBy: () => xorBy,
	xorWith: () => xorWith,
	zip: () => zip,
	zipObject: () => zipObject,
	zipObjectDeep: () => zipObjectDeep,
	zipWith: () => zipWith
});
//#endregion
export { compat_exports };
